import {emailInputRegex} from "../../../../../utils/globalConstants";
import {submitEvent} from "@otto-ec/tracking-bct";
import {HTMLOcButtonV1Element} from "@otto-ec/otto-components/dist-lib/components/button/v1/ButtonV1.types.g";
import {HTMLOcSheetV1Element} from "@otto-ec/otto-components/dist-lib/components/sheet/v1/SheetV1.types.g";

const newsletterSubscribeFooterEmailRegex = emailInputRegex
let newsletterSubscribeFooterValidForm = false;

const newsletterSubscribeFooterForm = document.getElementById(
  "newsletter-subscribe-footer-form"
);
const newsletterSubscribeFooterEmailInput = document.getElementById(
  "newsletter-subscribe-footer-email-input"
) as HTMLInputElement;

const newsletterSubscribeFooterError = document.getElementById(
  "newsletter-subscribe-footer-error"
);

const newsletterSubscribeFooterText = document.getElementById(
    "newsletter-subscribe-footer-text"
) as HTMLInputElement;

newsletterSubscribeFooterForm?.addEventListener(
  "submit",
  newsletterSubscribeFooterOnSubmitHandler
);
newsletterSubscribeFooterEmailInput?.addEventListener(
  "blur",
  validateNewsletterSubscribeFooterEmailInputHandler
);
newsletterSubscribeFooterEmailInput?.addEventListener(
    "click",
    showNewsletterSubscribeFooterText
);

const newsletterSubscribeFooterSheetCloseButton = document.querySelector<HTMLOcButtonV1Element>("#newsletter-subscribe-footer-sheet-close-button")
const newsletterSubscribeFooterSheet = document.querySelector<HTMLOcSheetV1Element>("#newsletter-subscribe-footer-sheet")
newsletterSubscribeFooterSheetCloseButton?.addEventListener("click", () => {
  newsletterSubscribeFooterSheet?.close();
});

function validateNewsletterSubscribeFooterEmailInputHandler() {
  const inputValue = newsletterSubscribeFooterEmailInput?.value;
  const invalidFormBanner = document.getElementById("invalid-form-banner");

  if (inputValue.match(newsletterSubscribeFooterEmailRegex)) {
    newsletterSubscribeFooterEmailInput.setAttribute("validation-message", "")
    invalidFormBanner!.style.display = "none";
    newsletterSubscribeFooterValidForm = true;
  } else if (inputValue === "") {
    newsletterSubscribeFooterEmailInput.setAttribute("validation-message", "Bitte trage eine gültige E-Mail-Adresse ein.")
    invalidFormBanner!.style.display = "none";
    newsletterSubscribeFooterValidForm = false;
  } else if (inputValue.length <= 5) {
    newsletterSubscribeFooterEmailInput.setAttribute("validation-message", "Deine E-Mail-Adresse darf nicht weniger als 6 Zeichen enthalten.")
    invalidFormBanner!.style.display = "none";
    newsletterSubscribeFooterValidForm = false;
  } else {
    newsletterSubscribeFooterEmailInput.setAttribute("validation-message", "Bitte überprüfe, ob deine eingegebene E-Mail-Adresse ein @-Zeichen und einen Punkt enthält.")
    invalidFormBanner!.style.display = "none";
    newsletterSubscribeFooterValidForm = false;
  }
}

function showNewsletterSubscribeFooterText() {
  newsletterSubscribeFooterText!.style.display = "unset";
}

function showErrorContent() {
  newsletterSubscribeFooterError!.style.display = "unset";
}

const sendNewsletterFooterSubscription = async (emailInput: string) => {
  const payload = {
    email: emailInput,
  };
  try {
    const response = await fetch("/newsletter-subscription/subscribe", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!(response.status >= 500)) {
      const validFormBanner = document.getElementById("valid-form-banner");
      validFormBanner!.style.display = "flex";
      showConfirmationEmailSheet();
      trackFooterSubscribeNlSuccess();
    } else {
      trackFooterSubscribeNlFailure();
      showErrorContent();
    }
  } catch (error) {
    console.error("Something went wrong:", error.message, error.name);
    showErrorContent();
  }
};

function showConfirmationEmailSheet() {
  newsletterSubscribeFooterSheet.open = true;
}

function newsletterSubscribeFooterOnSubmitHandler(e: Event) {
  e.preventDefault();
  validateNewsletterSubscribeFooterEmailInputHandler();
  if (newsletterSubscribeFooterValidForm === true) {
    const payloadEmailInputVal = newsletterSubscribeFooterEmailInput?.value;
    if (!!payloadEmailInputVal) {
      sendNewsletterFooterSubscription(payloadEmailInputVal);
    }
  } else {
    const invalidFormBanner = document.getElementById("invalid-form-banner");
    invalidFormBanner!.style.display = "flex";
    invalidFormBanner!.style.flexDirection = "column";
  }
}

/*                  */
function trackFooterSubscribeNlSuccess() {
  submitEvent({
    user_Permission: ['Newsletter'],
    user_PermissionActivity: ["true_ok_snippet"],
  });
}

function trackFooterSubscribeNlFailure() {
  submitEvent({
      user_Permission: ['Newsletter'],
      user_PermissionActivity: ["true_error_snippet"],
  });
}